// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3YSUO","list":"PatternAutocomplete_list__2-CwG"};